var _defs, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _polyline, _polyline2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCesFactSheetIconMeasurement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 203.03 115.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-Measurement-1{fill:none;stroke:#367c2b;stroke-linecap:round;stroke-linejoin:round;stroke-width:9.84px;}"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-Measurement-1",
    x1: 198.11,
    y1: 92.61,
    x2: 4.92,
    y2: 92.61
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-Measurement-1",
    x1: 18.85,
    y1: 75.06,
    x2: 18.85,
    y2: 110.15
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-Measurement-1",
    x1: 46.02,
    y1: 81.74,
    x2: 46.02,
    y2: 103.48
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-Measurement-1",
    x1: 73.2,
    y1: 81.74,
    x2: 73.2,
    y2: 103.48
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-Measurement-1",
    x1: 100.38,
    y1: 75.06,
    x2: 100.38,
    y2: 110.15
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-Measurement-1",
    x1: 127.56,
    y1: 81.74,
    x2: 127.56,
    y2: 103.48
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-Measurement-1",
    x1: 154.74,
    y1: 81.74,
    x2: 154.74,
    y2: 103.48
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-Measurement-1",
    x1: 182.89,
    y1: 75.06,
    x2: 182.89,
    y2: 110.15
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-Measurement-1",
    x1: 168.72,
    y1: 23.8,
    x2: 30.57,
    y2: 23.8
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-Measurement-1",
    points: "49.24 42.68 30.57 23.8 49.24 4.92"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-Measurement-1",
    points: "153.79 42.68 172.46 23.8 153.79 4.92"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCesFactSheetIconMeasurement);
export default __webpack_public_path__ + "static/media/CES-FactSheet-Icon_Measurement.4282f9f56819ebe6fed9b5d3f8247fbd.svg";
export { ForwardRef as ReactComponent };